module.exports = __webpack_public_path__ + "img/Billionaire-1.ba844bb9.png";